module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "chatSettingMenuContainer"
    }
  }, [_c('div', {
    attrs: {
      "id": "chatSettingMenuOpener",
      "title": "채팅설정"
    },
    on: {
      "click": _vm.showMenu
    }
  }, [_vm._v("채팅설정")]), _vm._v(" "), _c('settingMenuItem', {
    attrs: {
      "id": "chatSettingMenuItemContainer",
      "items": _vm.isAdmin ? _vm.items.concat(_vm.adminItems) : _vm.items
    }
  }), _vm._v(" "), (_vm.isAdmin) ? _c('settingMenuItem', {
    attrs: {
      "id": "chatAdminRemoteController",
      "items": _vm.remoteControllerItems
    }
  }) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-56f788ab"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/chat-setting-menu.vue
// module id = 100
// module chunks = 0